



















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
     Sections
 ---------------------------------------- */

import Mouse from '@layout/Mouse.vue';
import Popup from '@part/features/Popup.vue';

/* ----------------------------------------
     Module Helper
 ---------------------------------------- */

import { StoreModule } from "@store/service/Modules";
const module = new StoreModule('general');

/* ----------------------------------------
     Helpers
 ---------------------------------------- */

import { loader } from '@util/images';

/* ----------------------------------------
     Transitions
 ---------------------------------------- */

import * as transition from '@router/transitions/generic/fade'

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    components: {
        Mouse,
        Popup
    },

    mounted() {
        module.actions('setInit', true);
        const logo = document.querySelector('#logo');
        transition.fadeOut(logo, 500, 1000);
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class App extends Vue {}

